import { Briefcase, TrendingUp, Globe2, FileSignature, ListChecks } from "lucide-react";
import DocumentActions from "@/components/planner/DocumentActions";

const fmtRp = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

export default function CorporateResult({ result }) {
  return (
    <>
      <div data-testid="corporate-exec-block">
        <h3 className="font-heading font-extrabold text-xl text-slate-900 mb-5 flex items-center gap-2">
          <Briefcase className="w-5 h-5 text-emerald-600" /> Blok 1 — Executive Summary & Alokasi Dana
        </h3>
        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <p className="text-sm text-slate-700 leading-relaxed">{result.summary}</p>
          <div className="mt-5 space-y-3">
            {(result.budget_breakdown || []).map((b) => (
              <div key={b.label} className="flex items-center gap-4">
                <span className="w-44 shrink-0 text-xs font-bold text-slate-600">{b.label}</span>
                <div className="flex-1 h-2.5 bg-slate-100 rounded-full overflow-hidden">
                  <div className="h-full bg-emerald-600 rounded-full" style={{ width: `${b.pct}%` }} />
                </div>
                <span className="text-xs font-black text-slate-800 w-32 text-right">{b.pct}% · {fmtRp(b.amount)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div data-testid="corporate-esg-block">
        <h3 className="font-heading font-extrabold text-xl text-slate-900 mb-5 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-emerald-600" /> Blok 2 — Proyeksi ESG, SDGs & SROI
        </h3>
        <div className="grid md:grid-cols-2 gap-5">
          <div className="bg-white rounded-2xl border border-slate-200 p-6">
            <h4 className="font-heading font-extrabold text-sm text-slate-900 mb-3">Metrik ESG Terukur</h4>
            <ul className="space-y-2">
              {(result.esg_metrics || []).map((m, i) => (
                <li key={i} className="text-sm text-slate-600 flex gap-2"><span className="text-emerald-500 font-black">•</span>{m}</li>
              ))}
            </ul>
          </div>
          <div className="bg-slate-900 rounded-2xl p-6">
            <h4 className="font-heading font-extrabold text-sm text-white mb-3 flex items-center gap-1.5"><Globe2 className="w-4 h-4 text-emerald-400" /> Kontribusi SDGs</h4>
            <div className="flex flex-wrap gap-2 mb-4">
              {(result.sdgs || []).map((s) => (
                <span key={s.code} className="text-xs font-bold px-3 py-1.5 rounded-full bg-white/10 text-emerald-300 border border-emerald-500/30">{s.code} — {s.name}</span>
              ))}
            </div>
            <p className="text-xs text-slate-300 leading-relaxed"><b className="text-emerald-400">SROI:</b> {result.sroi}</p>
          </div>
        </div>
      </div>

      {result.phases?.length > 0 && (
        <div>
          <h3 className="font-heading font-extrabold text-xl text-slate-900 mb-5 flex items-center gap-2">
            <ListChecks className="w-5 h-5 text-emerald-600" /> Milestone Program
          </h3>
          <div className="grid md:grid-cols-3 gap-5">
            {result.phases.map((phase, i) => (
              <div key={i} className="bg-white rounded-2xl border border-slate-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-8 h-8 rounded-full bg-emerald-600 text-white font-black text-sm flex items-center justify-center shrink-0">{i + 1}</span>
                  <h4 className="font-heading font-extrabold text-slate-900 text-sm">{phase.name}</h4>
                </div>
                <ul className="space-y-2">
                  {phase.steps.map((s, j) => (
                    <li key={j} className="text-sm text-slate-600 flex gap-2"><span className="text-emerald-500 font-black">•</span>{s}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}

      <div data-testid="corporate-mou-block">
        <h3 className="font-heading font-extrabold text-xl text-slate-900 mb-5 flex items-center gap-2">
          <FileSignature className="w-5 h-5 text-emerald-600" /> Blok 3 — Draf MoU / Kerangka Acuan Kerja (TOR)
        </h3>
        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <div id="planner-document">
            <pre className="whitespace-pre-wrap text-sm text-slate-700 font-sans leading-relaxed">{result.mou_tor}</pre>
          </div>
          <DocumentActions text={result.mou_tor} summary={`${result.title}: ${result.summary}`} />
        </div>
      </div>
    </>
  );
}
